export default __webpack_public_path__ + "static/media/Ballroll_00051.566cbe24.png";